import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';

import { WidgetBase } from '../../../models/widget-base';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'fb-content-section',
  templateUrl: './fb-content-section.component.html',
  styleUrls: ['./fb-content-section.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbContentSectionComponent extends WidgetBase implements OnInit {
  public expanded = false;
  public expandedIndex = -1;
  @Input()
  public override set payload(value) {
    this._payload = value;
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }
  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  onExpandClick($event, index) {
    if (index === this.expandedIndex) {
      this.expandedIndex = -1;
    } else {
      this.expandedIndex = index;
    }
  }
  isExpanded(index) {
    return index === this.expandedIndex;
  }
}
